<template>
    <section class="latest-products" v-if="products.length > 0">
        <div class="container">
            <h1 class="text-center mb-4">Latest Products</h1>
            <div class="row g-1 mt-3">
                <div class="col-md-4 mb-3" v-for="product in products">
                    <div class="card">
                        <a :href="appUrl+'/products/'+product.id">
                            <div class="text-center"
                                v-if="product.images[0]"> 
                                <img :src="appUrl+'/'+product.images[0].image_path" 
                                    :alt="product.title" 
                                    class="img-fluid"
                                    width="100%"> 
                            </div>
                            <div class="text-center"
                                v-else> 
                                <img :src="appUrl+'/images/default-image.jpg'" 
                                    :alt="product.title" 
                                    class="img-fluid"
                                    width="100%"> 
                            </div>
                        </a>
                        <div class="product-details m-3 text-center">
                            <a :href="appUrl+'/products/'+product.id">
                                <span class="products-name d-block">{{ product.title }}</span>
                            </a>
                            <span class="products-price strike"
                                v-if="product.offer_price">
                                <i class="fa fa-rupee-sign"></i> 
                                {{ product.mrp }}
                            </span>
                            <span class="products-price"
                                v-else>
                                <i class="fa fa-rupee-sign"></i> 
                                {{ product.mrp }}
                            </span>
                            <span class="products-price"
                                v-if="product.offer_price">
                                <i class="fa fa-rupee-sign"></i> 
                                {{ product.offer_price }}
                            </span>
                            <div class="my-2 text-center">
                                <dl class="param param-inline">
                                    <dd>
                                        <b-form-spinbutton id="product-quantity"
                                            class="text-center"
                                            size="lg" 
                                            v-model="product.cart_quantity"
                                            min="0"
                                            :max="product.min_quantity * 10"
                                            :step="product.min_quantity"
                                            @change="addToCart(product.id, $event)"
                                            inline></b-form-spinbutton>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="view_more text-center mt-5 mb-5">
                <a class="cta-btn" :href="appUrl+'/products'">View All Products</a>
            </div>
            <hr>
        </div>
        <notifications group="cart" />
    </section>
</template>
<script>
    export default {
        computed: {},
        data() {
            return {
                products: [],
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
            };
        },
        mounted() {
            this.getLatestProducts();
        },
        methods: {
            getLatestProducts() {
                var that = this;
                axios.get('api/get-latest-products')
                .then(function(response) {
                    that.products = response.data.products;
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            addToCart(id, quantity) {
                var that = this;
                axios.post('api/add-to-cart', {
                    id: id,
                    quantity: quantity,
                })
                .then(function(response) {
                    if (response.data.success) {
                        that.$notify({
                            group: 'cart',
                            title: 'Success',
                            type: 'success',
                            text: response.data.message
                        });
                    } else {
                        that.$notify({
                            group: 'cart',
                            title: 'Error',
                            type: 'error',
                            text: response.data.message
                        });
                    }
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            }
        }
    };
</script>
